import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import outreachModalReducer from '../reducers/outreachModalReducer';

const configureStore = (railsProps) => (
  createStore(outreachModalReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
